import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { RoomType } from "../../utils/types";
import { Grid } from "@material-ui/core";
import { Vote } from "./Vote";
import { values } from "ramda";
import { getPattern } from "../../utils/PatternGenerator";

const useStyles = makeStyles((theme) => ({
  table: {
    gap: "1em",
    margin: "2em 0",
    justifyContent: "center",
  },
}));

type VotesTableProps = {
  room: RoomType;
  showVotes: boolean;
};

const VotesTable: React.FC<VotesTableProps> = ({ room, showVotes }) => {
  const classes = useStyles();
  const participatingUsers = values(room.users).filter(user => user.observer === false);

  return (
    <Grid container className={classes.table} direction="row">
      {participatingUsers.map((user) => (
        <Vote
          key={user.id}
          show={showVotes}
          username={user.name}
          vote={user.estimate}
          pattern={room.users[user.id].pattern || getPattern(room)}
        />
      ))}
    </Grid>
  );
};

export default VotesTable;
